import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../../Forms/BorderedFormGrid";
import { MdmFormProps } from "../../../../Forms/MdmFormProps";
import { TextFieldInput } from "../../../../Forms/TextFieldInput";
import { RateAgreement } from "../../RateAgreement";

export const RateAgreementBase = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<RateAgreement>();

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput
          control={control}
          name="RateAgreementNumber"
          label="Rate Agreement Number"
          required
          disabledFields={disabledFields}
          type="number"
        />
      </Grid>
      <Grid item xs={2}>
        <TextFieldInput control={control} name="Version" disabledFields={disabledFields} />
      </Grid>
      {/* PLACEHOLDER */}
      <Grid item xs={7} />
    </BorderedFormGrid>
  );
};
